module.exports = __webpack_public_path__ + "img/redbooklogo.69c820f6.png";